import react, { useEffect } from "react";

const GuideWork = (props) => {

    const { 
        work,
        setWork
    } = props;

    return (
        <div className="form-group">
            <label htmlFor="work">What do you do for work?</label>
            <select 
                className="work-group"
                id="work" 
                name="work" 
                required 
                value={work} 
                onChange={(e) => setWork(e.target.value)}>
                <option value="" disabled>Select your industry</option>

                <option value="technology">Technology / Software</option>
                <option value="finance">Finance / Banking / Accounting</option>
                <option value="healthcare">Healthcare / Medical</option>
                <option value="education">Education / Academia</option>
                <option value="manufacturing">Manufacturing / Industrial</option>
                <option value="construction">Construction / Real Estate</option>
                <option value="retail">Retail / Consumer Goods</option>
                <option value="hospitality">Hospitality / Food & Beverage</option>
                <option value="transportation">Transportation / Logistics</option>
                <option value="energy">Energy / Utilities</option>
                <option value="media">Media / Entertainment</option>
                <option value="marketing">Marketing / Advertising / PR</option>
                <option value="design">Design / Creative</option>
                <option value="legal">Legal</option>
                <option value="government">Government / Public Service</option>
                <option value="nonprofit">Non-Profit / NGO</option>
                <option value="agriculture">Farming / Agriculture</option>
                <option value="science">Science / Research</option>
                <option value="telecom">Telecommunications</option>
                <option value="military">Military / Defense</option>

                <option value="student">Student</option>
                <option value="self_employed">Self-Employed / Freelancer</option>
                <option value="unemployed">Not Currently Employed</option>
                <option value="retired">Retired</option>
                <option value="other">Other</option>
            </select>
        </div>
        )
    }

export default GuideWork;